/** Public policy advertises only actions backed by the installed native mutation boundary. */
export type JobScheduleMutationAction = 'create-stage' | 'create-phase' | 'update-stage' | 'update-phase' | 'reparent' | 'remove-phase' | 'assign-staff';

/** Native commands use the existing tenant entity transport, independently of the legacy Job strategy. */
export enum NativeJobGanttCommandId {
    GetContext = 'GetContext',
    PreviewSchedule = 'PreviewSchedule',
    CommitSchedule = 'CommitSchedule',
    MutateSchedule = 'MutateSchedule',
}
